import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import api from "../../api";
import "./PlatformStats.scss";

const formatCount = (n) => {
  if (n == null || Number.isNaN(n)) return "-";
  return Number(n).toLocaleString();
};

/** Quiet trust strip without a competing CTA */
const PlatformStats = () => {
  const [ref, inView] = useInView({ triggerOnce: true, rootMargin: "120px" });
  const [userCount, setUserCount] = useState(null);
  const [retailerCount, setRetailerCount] = useState(null);
  const [fetched, setFetched] = useState(false);

  useEffect(() => {
    if (!inView || fetched) return;
    setFetched(true);
    api
      .getPlatformStats()
      .then((data) => {
        setUserCount(data.userCount ?? 0);
        setRetailerCount(data.retailerCount ?? 0);
      })
      .catch(() => {
        setUserCount(null);
        setRetailerCount(null);
      });
  }, [inView, fetched]);

  const ready = userCount != null || retailerCount != null;

  return (
    <motion.div
      id="platform-stats"
      className="platform-stats"
      ref={ref}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: ready && inView ? 1 : 0, y: ready && inView ? 0 : 16 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      style={ready ? undefined : { minHeight: 0, padding: 0, margin: 0, border: "none" }}
      aria-hidden={!ready}
    >
      {ready ? (
        <>
          <p className="platform-stats__kicker">Already on OllaCart</p>
          <div className="platform-stats__inner">
            <div className="platform-stats__item">
              <span className="platform-stats__value">
                {formatCount(userCount)}
              </span>
              <span className="platform-stats__label">Shoppers</span>
            </div>
            <div className="platform-stats__divider" aria-hidden="true" />
            <div className="platform-stats__item">
              <span className="platform-stats__value">
                {formatCount(retailerCount)}
              </span>
              <span className="platform-stats__label">Retailers</span>
            </div>
          </div>
        </>
      ) : null}
    </motion.div>
  );
};

export default PlatformStats;
